import React, { useEffect, useState } from 'react'
import browserLang from 'browser-lang'
import { withPrefix } from 'gatsby'
import { IntlProvider } from 'react-intl'
import { IntlContextProvider } from './intl-context'
import * as axios from 'axios'
import { i18nHost, i18nMap, i18nTypes } from '@src/resources/i18n/config'
import { setCurrentLang } from '@src/utils'

// const preferDefault = m => (m && m.default) || m
//
// const polyfillIntl = language => {
//   const locale = language.split('-')[0]
//   try {
//     if (!Intl.PluralRules) {
//       require('@formatjs/intl-pluralrules/polyfill')
//       require(`@formatjs/intl-pluralrules/dist/locale-data/${locale}`)
//     }
//
//     if (!Intl.RelativeTimeFormat) {
//       require('@formatjs/intl-relativetimeformat/polyfill')
//       require(`@formatjs/intl-relativetimeformat/dist/locale-data/${locale}`)
//     }
//   } catch (e) {
//     throw new Error(`Cannot find react-intl/locale-data/${language}`)
//   }
// }

const i18nCache = {}
Object.keys(i18nMap).forEach(async item => {
  i18nCache[item] = null
  const result = await axios.get(`https://${i18nHost}/seagull/i18n-request?spaceName=anan-life-responsive&businessCode=Life&languageType=${i18nTypes[item]}`)
  if (result.status === 200 && result.data.success && result.data.code === 200) {
    i18nCache[item] = result.data.data.contentMap
  }
})

const PageApp = (props) => {
  const { children } = props
  const { intl, intl: { language, defaultLanguage } } = props
  const [messages, setMessages] = useState(intl.messages)
  // console.log('languageLoad ', languageLoad)
  useEffect(() => {
    async function updateI18nWords () {
      const result = await axios.get(`https://${i18nHost}/seagull/i18n-request?spaceName=anan-life-responsive&businessCode=Life&languageType=${i18nTypes[language]}`)
      if (result.status === 200 && result.data.success && result.data.code === 200) {
        i18nCache[language] = result.data.data.contentMap
        // messages = i18nCache[language]
        setMessages(i18nCache[language])
        // actions.mainModel.setLanguageLoad(true)
        // changeLocale(language)
      }
    }

    i18nCache[language] && setMessages(i18nCache[language])
    !i18nCache[language] && updateI18nWords()
    setCurrentLang(i18nTypes[language])
  }, [language])

  useEffect(() => {
    window.location.pathname.replace(/\/+$/, '')
  })

  return (
    <IntlProvider
      key={language}
      locale={language}
      defaultLocale={defaultLanguage}
      messages={messages}
    >
      <IntlContextProvider value={intl}>
        {children}
      </IntlContextProvider>
    </IntlProvider>
  )
}

export default ({ element, props }, pluginOptions) => {
  if (!props) {
    return
  }

  const { pageContext, location } = props
  // const { defaultLanguage } = pluginOptions
  const { intl } = pageContext
  const { language, languages, redirect, routed, originalPath } = intl

  if (typeof window !== 'undefined') {
    window.___gatsbyIntl = intl
  }
  /* eslint-disable no-undef */
  const isRedirect = redirect && !routed

  if (isRedirect) {
    const { search } = location

    // Skip build, Browsers only
    if (typeof window !== 'undefined') {
      let detected =
        window.localStorage.getItem('gatsby-intl-language') ||
        browserLang({
          languages,
          fallback: language
        })

      if (!languages.includes(detected)) {
        detected = language
      }

      const queryParams = search || ''
      const newUrl = withPrefix(`/${detected}${originalPath}${queryParams}`)
      window.localStorage.setItem('gatsby-intl-language', detected)
      window.location.replace(newUrl)
    }
  }
  // const renderElement = isRedirect
  //   ? GATSBY_INTL_REDIRECT_COMPONENT_PATH &&
  //   React.createElement(
  //     preferDefault(require(GATSBY_INTL_REDIRECT_COMPONENT_PATH))
  //   )
  //   : element
  return (
    <PageApp intl={intl}>
      {element}
    </PageApp>
  )
}
